import { memo } from "react";
import { useTranslation } from "react-i18next";

import InviteCustomers from "../InviteCustomers";

import Input from "../Input";
import CustomDatePicker from "../CustomDatePicker";
import CustomTimePicker from "../CustomTimePicker";
import DurationInput from "../DurationInput";

import { isOnlyNumbers, formatDate, formatDuration } from "../../utils/helpers";

import { ReactComponent as CalendarIcon } from "../../static/images/calendar_green.svg";
import { ReactComponent as EmailIcon } from "../../static/images/email.svg";
import { ReactComponent as PhoneIcon } from "../../static/images/dial-icon.svg";

import "./style.scss";

const OnetimeFlow = memo(
  ({
    formData,
    handleFormFieldChange,
    currentStep,
    setInviteInputValue,
    inviteCutomer,
    deleteCustomer,
    invitedCustomers,
    errors,
    currency,
  }) => {
    const { t } = useTranslation();

    return (
      <>
        {currentStep === 2 ? (
          <>
            <h3>{t("session_details")}</h3>

            <h4 className="onetime-date-section-header">
              {t("createSchedule.onetimeFlow.date_label")}
            </h4>
            <CustomDatePicker
              label={t("input_label_event_date")}
              name="eventDate"
              value={formData.eventDate}
              onChange={handleFormFieldChange}
              minDate={new Date()}
              error={
                errors.eventDate
                  ? t("createSchedule.common.input_error_required")
                  : ""
              }
            />

            <CustomTimePicker
              label={t("input_label_event_time")}
              name="eventTime"
              value={formData.eventTime}
              onChange={handleFormFieldChange}
              error={
                errors.eventTime
                  ? t("createSchedule.common.input_error_required")
                  : ""
              }
            />
            <DurationInput
              label={t("createSchedule.common.duration_label")}
              onChange={handleFormFieldChange}
              valueHour={formData.durationHours}
              valueMin={formData.durationMin}
              errorfromparent={
                errors.duration
                  ? t("createSchedule.common.input_error_required")
                  : ""
              }
            />

            <Input
              label={t("createSchedule.onetimeFlow.name_label")}
              name="scheduleName"
              value={formData.scheduleName}
              onChange={handleFormFieldChange}
              required
              hasError={errors.scheduleName}
              errorText={
                errors.scheduleName
                  ? t("createSchedule.common.input_error_required")
                  : ""
              }
            />

            <Input
              type="number"
              label={t("createSchedule.onetimeFlow.price_label")}
              name="price"
              value={formData.price}
              onChange={handleFormFieldChange}
              required
              hasError={errors.price}
              errorText={
                errors.price
                  ? t("createSchedule.common.input_error_required")
                  : ""
              }
            />
          </>
        ) : currentStep === 3 ? (
          <InviteCustomers
            setInviteInputValue={setInviteInputValue}
            inviteCutomer={inviteCutomer}
            deleteCustomer={deleteCustomer}
            invitedCustomers={invitedCustomers}
            maxNumber={100}
            errorfromparent={errors.inviteInput}
          />
        ) : (
          <div className="review-section">
            <div className="review-header">
              <CalendarIcon />
              <h4>{t("createSchedule.reviewSection.onetime.header_title")}</h4>
            </div>
            <div className="review-date">
              <h4>{t("createSchedule.common.date_timing_title")}</h4>
              <p>{`${formatDate(formData.eventDate, t)} ${formData.eventTime}`}</p>
              <p>{formatDuration(formData.duration)}</p>
            </div>
            <div className="review-price">
              <h4>{t("createSchedule.reviewSection.pricing_title")}</h4>
              <p>
                {currency} {formData.price}
              </p>
            </div>
            {invitedCustomers.length > 0 && (
              <div className="review-cusomers">
                <h4>{t("createSchedule.common.invited_customers_title")}</h4>
                {invitedCustomers.map((customer) => (
                  <p key={customer.id}>
                    {isOnlyNumbers(customer.contact) ? (
                      <PhoneIcon />
                    ) : (
                      <EmailIcon />
                    )}
                    {customer.contact}
                  </p>
                ))}
              </div>
            )}
          </div>
        )}
      </>
    );
  },
);

export default OnetimeFlow;
